<template>
  <div class="main-content">
    <div class="card p-2 mb-2">
      <h5 class="mb-1">Auditoria — Exclusões de Ocorrências</h5>
      <p class="text-muted mb-2" style="font-size: 13px">
        Registro permanente de todas as exclusões de ocorrências (mantido mesmo após a exclusão).
      </p>
      <div class="row">
        <div class="col-md-4">
          <label>Nº Ocorrência</label>
          <input
            type="text"
            class="form-control"
            v-model="filters.external_id"
            @keyup.enter="fetchLogs(1)"
            placeholder="Buscar por nº"
          />
        </div>
        <div class="col-md-3 d-flex align-items-end mt-2">
          <button class="btn btn-primary" @click="fetchLogs(1)">Filtrar</button>
        </div>
      </div>
    </div>

    <div class="card p-1">
      <div class="table-responsive">
        <table class="table table-bordered table-hover table-sm">
          <thead>
            <tr>
              <th>Nº Ocorrência</th>
              <th>ID Interno</th>
              <th>Excluído por</th>
              <th>Data / Hora</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="logs.length === 0">
              <td colspan="5" class="text-center text-muted py-3">
                Nenhuma exclusão registrada.
              </td>
            </tr>
            <tr v-for="log in logs" :key="log.id">
              <td>{{ log.external_id || "—" }}</td>
              <td>{{ log.occurrence_id }}</td>
              <td>{{ log.user_name || "—" }}</td>
              <td>{{ formatDate(log.created_at) }}</td>
              <td>{{ log.ip_address || "—" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-6 mt-1 mx-auto d-flex justify-content-center">
        <pagination
          :records="total"
          :options="options"
          :per-page="20"
          @paginate="fetchLogs"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";

export default {
  name: "DeletionLogsIndex",
  components: { Pagination },
  data() {
    return {
      filters: { external_id: "" },
      logs: [],
      total: 0,
      options: {
        texts: { count: "Mostrando {from} de {to} até {count} de registros" },
        chunk: 4,
        chunksNavigation: "fixed",
      },
    };
  },
  methods: {
    fetchLogs(page) {
      const self = this;
      const p = page || 1;
      let api =
        self.$store.state.api + "occurrences/deletion-logs?page=" + p;
      if (self.filters.external_id) {
        api += "&external_id=" + encodeURIComponent(self.filters.external_id);
      }
      axios
        .get(api)
        .then((response) => {
          self.logs = response.data.data;
          self.total = response.data.total;
        })
        .catch((error) => {
          self.$message(
            null,
            (error.response && error.response.data) || "Erro ao carregar logs",
            "error"
          );
        });
    },
    formatDate(value) {
      if (!value) return "—";
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      const pad = (n) => String(n).padStart(2, "0");
      return (
        pad(d.getDate()) +
        "/" +
        pad(d.getMonth() + 1) +
        "/" +
        d.getFullYear() +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
      );
    },
  },
  mounted() {
    this.fetchLogs();
  },
};
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.table th,
.table td {
  text-align: center;
}
</style>
